module.exports = __webpack_public_path__ + "static/media/s7.53c31d90.ogg";